// extracted by mini-css-extract-plugin
export default {"button":"ButtonItem_button__jRTaY","document":"ButtonItem_document__nKDvi"};